import { render, staticRenderFns } from "./ConfigurationTypePaymentsCard.vue?vue&type=template&id=42a7643c&scoped=true&"
import script from "./ConfigurationTypePaymentsCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTypePaymentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7643c",
  null
  
)

export default component.exports